module.exports = __webpack_public_path__ + "img/alarm-fill.464c5ae5.svg";